(() => {
  const roots = Array.from(document.querySelectorAll('[data-kk-wpf-root][data-kk-wpf-mode="full"]'));

  roots.forEach((root) => {
    const furnitureCards = Array.from(root.querySelectorAll('[data-kk-wpf-furniture]'));
    const panels = Array.from(root.querySelectorAll('[data-kk-wpf-panel]'));
    const status = root.querySelector('[data-kk-wpf-status]');

    if (!furnitureCards.length || !panels.length) return;

    const getHandle = () => {
      try {
        return new URL(window.location.href).searchParams.get('moebel') || '';
      } catch (error) {
        return '';
      }
    };

    const findCard = (handle) => furnitureCards.find((card) => card.dataset.furnitureHandle === handle);
    const findPanel = (handle) => panels.find((panel) => panel.dataset.furnitureHandle === handle);

    const announce = (message, hidden = false) => {
      if (!status) return;
      status.textContent = message;
      status.hidden = hidden;
    };

    const selectFurniture = (handle, options = {}) => {
      const { push = false, scroll = false, scrollBehavior = 'smooth' } = options;
      const card = findCard(handle);
      const panel = findPanel(handle);
      const valid = Boolean(card && panel);

      furnitureCards.forEach((item) => {
        const active = item === card;
        item.setAttribute('aria-pressed', String(active));
      });

      panels.forEach((item) => {
        const active = item === panel;
        item.hidden = !active;
        item.setAttribute('aria-hidden', String(!active));
      });

      if (!valid) {
        announce(handle
          ? 'Die übergebene Möbel-Auswahl ist nicht verfügbar. Bitte wähle ein Möbel aus.'
          : 'Wähle dein Möbel oder Gerät.');
        return;
      }

      announce('', true);

      if (push) {
        try {
          const nextUrl = new URL(window.location.href);
          nextUrl.searchParams.set('moebel', handle);
          window.history.pushState({ moebel: handle }, '', `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`);
        } catch (error) {
          // The visible state still works if the browser disallows history updates.
        }
      }

      if (scroll && panel) {
        const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const scrollToPanelProduct = () => {
          const firstProductMedia = panel.querySelector('.kk-wpf__attachment-media');
          const firstProductCard = panel.querySelector('[data-kk-wpf-attachment], .kk-wpf__attachment-card');
          const scrollTarget = firstProductMedia || firstProductCard || panel;
          const fixedOffset = Array.from(document.querySelectorAll('header')).reduce((offset, element) => {
            const style = window.getComputedStyle(element);
            const rect = element.getBoundingClientRect();
            if ((style.position === 'fixed' || style.position === 'sticky') && rect.top <= 1 && rect.bottom > 0) {
              return Math.max(offset, rect.bottom);
            }
            return offset;
          }, 0);
          scrollTarget.scrollIntoView({
            block: 'start',
            behavior: 'auto'
          });
          window.setTimeout(() => {
            window.scrollBy({ top: -(fixedOffset + 16), behavior: 'auto' });
          }, reduceMotion ? 0 : 50);
        };
        window.setTimeout(() => {
          window.requestAnimationFrame(scrollToPanelProduct);
        }, 100);
      }
    };

    furnitureCards.forEach((card) => {
      card.addEventListener('click', () => {
        selectFurniture(card.dataset.furnitureHandle || '', { push: true, scroll: true });
      });
    });

    window.addEventListener('popstate', () => selectFurniture(getHandle()));

    const cartAddButtons = Array.from(root.querySelectorAll('[data-kk-wpf-add-to-cart]'));
    cartAddButtons.forEach((button) => {
      const card = button.closest('[data-kk-wpf-attachment]');
      const isShelfButton = button.hasAttribute('data-kk-wpf-shelf-add');
      const variantSelect = !isShelfButton && card ? card.querySelector('[data-kk-wpf-variant-select]') : null;
      const message = isShelfButton
        ? button.closest('[data-kk-wpf-shelf-recommendation]')?.querySelector('[data-kk-wpf-shelf-message]')
        : card ? card.querySelector('[data-kk-wpf-add-message]') : null;

      if (variantSelect) {
        variantSelect.addEventListener('change', () => {
          button.dataset.variantId = variantSelect.value;
        });
      }

      button.addEventListener('click', async () => {
        if (button.disabled) return;

        const variantId = button.dataset.variantId || (variantSelect && variantSelect.value);
        if (!variantId) return;

        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        if (message) message.textContent = 'Wird zum Warenkorb hinzugefügt …';

        try {
          const shopifyRoot = window.Shopify?.routes?.root || '/';
          const cartAddUrl = shopifyRoot.replace(/\/?$/, '/') + 'cart/add.js';
          const response = await fetch(cartAddUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/x-www-form-urlencoded',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: new URLSearchParams({ id: String(variantId), quantity: '1' }).toString()
          });
          const result = await response.json();

          if (!response.ok || result.status === 422) {
            throw new Error(result.description || result.message || (isShelfButton
              ? 'Das Regal konnte nicht hinzugefügt werden.'
              : 'Der Wickelaufsatz konnte nicht hinzugefügt werden.'));
          }

          if (typeof window.renderHelperCart === 'function') {
            const helperResponse = await fetch('?section_id=helper-cart');
            if (helperResponse.ok) {
              window.renderHelperCart(await helperResponse.text());
            }
          }

          const cartForm = document.getElementById('AjaxCartForm');
          if (cartForm) cartForm.dispatchEvent(new Event('cart-updated'));

          if (window.KROWN?.functions?.eventDispatcher) {
            window.KROWN.functions.eventDispatcher('krown:cart:add', {
              variantId: String(variantId),
              quantity: 1,
              source: 'kk-wickelplatz-finder'
            });
          }

          button.textContent = isShelfButton ? 'Regal im Warenkorb ✓' : 'Zum Warenkorb hinzugefügt ✓';
          if (message) message.textContent = isShelfButton
            ? 'Das Stauraumregal liegt im Warenkorb.'
            : 'Der Wickelaufsatz liegt im Warenkorb.';
          const screenReader = document.getElementById('screen-reader-info');
          if (screenReader) {
            screenReader.textContent = isShelfButton
              ? 'Das Stauraumregal wurde zum Warenkorb hinzugefügt.'
              : 'Der Wickelaufsatz wurde zum Warenkorb hinzugefügt.';
          }
        } catch (error) {
          button.disabled = false;
          if (message) message.textContent = error?.message || 'Bitte versuche es erneut.';
        } finally {
          button.removeAttribute('aria-busy');
        }
      });
    });

    const initialHandle = getHandle();
    selectFurniture(initialHandle, {
      scroll: Boolean(initialHandle),
      scrollBehavior: 'auto'
    });
  });
})();
